import {  ExerciseModule} from './traning.module';
import {Subscription } from  'rxjs';
import {NgForm} from '@angular/forms';
import { Injectable} from  '@angular/core';
import { AngularFirestore} from 'angularfire2/firestore';
import {AngularFireAuth} from    'angularfire2/auth';
import { map,take} from 'rxjs/operators';
import { uiService} from '../shared/ui-services';
import { TraningRoutingModule} from './traning.routes';
import { traningImportModule} from './traning.imports';
import {Store} from '@ngrx/store';
import * as UI from '../shared/ui.actions';
import * as TraningAction from './traning.actions';
import * as fromTraning from './traning.reducer';
@Injectable()
export class Exercises  {

   fireSubscription:Subscription[] = [];
   excerciseData:ExerciseModule[]=[];
   availableExcercise: ExerciseModule[] ;
private runninExercise :ExerciseModule;

constructor (private db:AngularFirestore,private UiService:uiService,private store:Store<fromTraning.State>,private fireAuth:AngularFireAuth){ }

    onSelect(id:string){

            this.store.dispatch(new TraningAction.startTraning(id));
    };

  ///// Fetching Available Exercises /////

    fetchavailableExcercise(){
  
        this.store.dispatch(new UI.StartLoading());
    
     this.fireSubscription.push(   this.db
        .collection('availableExercises')
        .snapshotChanges()
        .pipe(map(docArray =>{
              //  throw(new Error());
              return docArray.map(doc =>
               {
                return {
                id:doc.payload.doc.id,
                ...doc.payload.doc.data()
                }
            })       
            
        }))
        .subscribe((result:ExerciseModule[]) =>{
            this.store.dispatch(new UI.StopLoading());
            this.store.dispatch(new TraningAction.setAvailableTraning(result));
        },error => {
             this.store.dispatch(new UI.StopLoading());
            this.UiService.showSnackBar("Sorry Network Problem We Cann't Fetched Exercises",null,4000);
            
        }));
    }

  getRunningService(){
      return {...this.runninExercise} ;
  }
   cancelTraning(Progress:number){

    this.store.select(fromTraning.getActiveTraning).pipe(take(1)).subscribe(ex =>{

            this.addDataToFinishedExcercise({...ex,
                duration:ex.duration*(Progress /100),
                calories:ex.duration * (Progress /100),
                date:new Date(),               
                state:'Cancelled'});
                this.store.dispatch(new TraningAction.stopTraning());


    })
        



   }

   completedTraning(){
       this.store.select(fromTraning.getActiveTraning).pipe(take(1)).subscribe(ex =>{
                
                this.addDataToFinishedExcercise({
                    ...ex,
                    date:new Date(),state:'Completed'});
                 this.store.dispatch(new TraningAction.stopTraning());
   
       })
   }
    
    fetchFinsishedExercise(){
    this.fireAuth.authState.subscribe(user =>{
            if(user){
     this.fireSubscription.push(   this.db.collection('finishedExercise').doc(user.uid).collection('PastExercise').valueChanges().subscribe((pastExercises:ExerciseModule[])=>{
           this.store.dispatch(new TraningAction.setFinishedTraning(pastExercises));
     
        }))
    
    };  
    });
    }
   private  addDataToFinishedExcercise(exerceise:ExerciseModule){
       this.fireAuth.authState.subscribe(user =>{
                if(user){
                       this.db.collection('finishedExercise').doc(user.uid).collection('PastExercise').add(exerceise);
                  
                }  
       })
//        .add(exerceise);
    
}

    cancelSubscription(){
        this.fireSubscription.forEach(sub => sub.unsubscribe());
    }  
}